<template lang="pug">
  .two-col(:class="[spacingTop, spacingBottom]" v-if="contents && contents.length")
    .content-wrap
        .heading(v-if="title || subTitle", :class="textAlignment")
            h2.title(v-if="title") {{ title }}
            <hr v-if="showLine" :class="textAlignment">
            h3.sub_title(v-if="subTitle") {{ subTitle }}
        .rte
            .rte-area(v-if="content1 && content1.text" v-html="content1.text")
            .rte-area(v-if="content2 && content2.text" v-html="content2.text")
</template>

<script>
import { get } from '@/helpers';
export default {
    name: 'Post2Cols',
    props: {
        section: {
            type: Object,
            required: true
        }
    },
    computed: {
        contents() {
            return this.section.contents || [];
        },
        heading() {
            return this.contents.find(content => content.key === 'heading');
        },
        title() {
            return get(this.heading, 'title');
        },
        subTitle() {
            return get(this.heading, 'sub_title');
        },
        content1() {
            return this.contents.find(content => content.key === 'content-1');
        },
        content2() {
            return this.contents.find(content => content.key === 'content-2');
        },
        textAlignment() {
            let alignment = 'text-center';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'text_alignment');
                if (setting && setting.value !== undefined) alignment = setting.value;
            }

            return alignment;
        },
        showLine() {
            let showLine = false;

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'show_line');
                if (setting && setting.value !== undefined) showLine = setting.value;
            }

            return showLine;
        },
        spacingTop() {
            let spacingTop = 'spacingTopStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingTop');
                if (setting && setting.value !== undefined) spacingTop = setting.value;
            }
            return spacingTop;
        },
        spacingBottom() {
            let spacingBottom = 'spacingBottomStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingBottom');
                if (setting && setting.value !== undefined) spacingBottom = setting.value;
            }
            return spacingBottom;
        }
    }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"
.two-col
    .heading
        @apply mb-6
    .rte
        @apply grid grid-cols-1 gap-8
        @screen md
            @apply grid-cols-2 gap-10
</style>
